import { DownloadIcon, ButtonIcon, Tooltip } from 'canoe';
import { ENDPOINTS, useActions } from 'hammock';
import Papa from 'papaparse';
import React from 'react';

interface DownloadButtonProps {
  setId: string;
}

const downloadString = (text: string, fileType: string, fileName: string) => {
  const blob = new Blob([text], { type: fileType });

  const a = document.createElement('a');
  a.download = fileName;
  a.href = URL.createObjectURL(blob);
  a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => {
    URL.revokeObjectURL(a.href);
  }, 1500);
};

export const DownloadButton = ({ setId }: DownloadButtonProps) => {
  const { action } = useActions(ENDPOINTS.segmentsDefinition);

  const handleDownload = async () => {
    // @ts-ignore
    const items: string[] = await action({
      name: 'getSetItems',
      query: { setId },
    });

    if (!items) {
      return;
    }

    const csv = Papa.unparse({
      fields: ['value'],
      data: items.map((item) => [item]),
    });

    downloadString(csv, 'text/csv', `${setId}.csv`);
  };
  return (
    <Tooltip placement="top" content="Download CSV">
      <ButtonIcon icon={DownloadIcon} aria-label="Download CSV" onClick={handleDownload} mt="xxs" />
    </Tooltip>
  );
};
